import { OpeningHoursTab } from "./OpeningHours"
import { PracticalInformationTab } from "./PracticalInformation"

export const tabs = [OpeningHoursTab, PracticalInformationTab]
export const defaultValues = {
  ...OpeningHoursTab.defaultValues,
  ...PracticalInformationTab.defaultValues,
}
